// extracted by mini-css-extract-plugin
export var backupIcon = "_nc-1";
export var image = "_nc-0";